import { CommonPagesToHave, CommonPageType, getPageSpecificInstructionsAndComponents } from "@builder/utils/JSXtoBuilder/architecture/pagesAndComponentsInfo";
import { tool, StreamTextOnChunkCallback } from "ai";
import { z } from "zod";
import { renameLayer, seeJSXOfNode } from "./globalTools";
import { editDesignWithAI } from "./DesignAI/designAI";
import { searchLayerByName } from "./helpers";


export const generateToolSet = ({onChunk, abortSignal}: {onChunk?: StreamTextOnChunkCallback<any>; abortSignal?: AbortSignal}) => {
    return {
    seeJSXOfLayer: tool({
        description: "Return the JSX string for the requested layer. If no layerId is supplied, the current layer is returned.",
        parameters: z.object({
            layerId: z.string().optional().describe("(Optional) The id of the layer to inspect. If omitted, the current layer is used.")
        }),
        execute: async ({ layerId }) => {
            return seeJSXOfNode(layerId);
        }
    }),
    renamePage: tool({
        description: "Rename the current page. Use this when the user asks to rename the page.",
        parameters: z.object({
            name: z.string().describe("The new name of the page."),
            layerId: z.string().describe("The id of the layer to rename. If omitted, the current layer is used.")
        }),
        execute: async ({ name, layerId }) => {
            return renameLayer(layerId, name);
        }
    }),
    findPage: tool({
        description: "Find a page / popup / customer facing display page  - by name. Use this if you need to get the layerId of a page / popup / customer facing display page in order to edit it or inspect it. If there is more than one page with the same name, you should clarify with the user.",
        parameters: z.object({
            name: z.string().describe("The name of the page to find.")
        }),
        execute: async ({ name }) => {
            return searchLayerByName(name);
        }
    }),
    getPageInstructons: tool({
        description: "Get information about the current page purpose and components. Use this when the user asks about the page.",
        parameters: z.object({
            pageType: z.enum(Object.keys(CommonPagesToHave) as [string, ...string[]]).describe("The type of the page.")
        }),
        execute: async ({ pageType }) => {
            return getPageSpecificInstructionsAndComponents(pageType as CommonPageType);
        }
    }),
    editDesign: tool({
        description: "Edit the design of the current page or a specific node.",
        parameters: z.object({
            userPrompt: z.string().describe("The prompt from the user describing how to edit the design."),
            layerId: z.string().describe("The id of the layer (page/popup/etc.) to edit."),
            startingNodeId: z.string().optional().describe("(Optional) The id of the node within the layer to start editing from NOLY IF YOU KNOW IT. If omitted, edits the root of the layer which is fine too"),
            pageType: z.enum(Object.keys(CommonPagesToHave) as [string, ...string[]]).optional().describe("(Optional) Target page type it should be, like if you want it to become a product-page or if it is already clearly a product-page / order-page etc. If you are not sure, omit it.")
        }),
        execute: async ({ userPrompt, layerId, startingNodeId, pageType }) => {
            try {
                return editDesignWithAI({ userPrompt, layerId, startingNodeId, pageType: pageType as CommonPageType, onChunk, abortSignal });
            } catch (error) {
                console.error("Error editing design", error);
                return `Error editing design: ${error}`;
            }
        }
    }),


}
}
